export class Messages  {

    static readonly loginSessionExpired: string = 'Another session has already been started in a different browser and as a result this session has been expired.';

    static readonly loginSessionTimedOut: string =  'Your session has timed out. Please log in again.';

    static readonly cannotEditCancelledCirf: string =  'This client information request is cancelled and cannot be modified.';

    static readonly cannotEditExpiredCirf: string =  'This client information request has expired and cannot be modified.';

    static readonly invalidMatterSummarySelected: string =  'There was an error with selected transactions.';

    static readonly invalidUnityTransactionSelected: string =  'Invalid transaction selected.';

    static readonly userLocked: string = 'Your credentials have been locked.  Please contact your administrator.';

    static readonly internalError: string = 'Unexpected error happened on Server, please try later or contact the Administrator.';

    static readonly reusedPassword: string = 'Unable to update the password. You cannot reuse one of your last 5 passwords.';

    static readonly reCaptchaFailed: string = 'Error verifying reCAPTCHA, please try again.';

    static readonly areYouSureYouWantToDeleteThisDocument: string = 'Are you sure you want to delete this document?';

}
